import { useRef, useState } from 'react'
import { Box } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react'
import SectionCarouselHeader, { SectionCarouselFooterNav } from '../common/SectionCarouselHeader'
import StoryVideoCard from '../common/StoryVideoCard'
import { inspiringStories } from '../../data/homeContent'
import {
  HOME_MOBILE_MQ,
  homeMobilePaddingX,
  homeSectionPy,
  homeSectionTitleSx,
} from './homeMobileLayout'
import { SLIDER_TRANSITION_SPEED_DEFAULT } from '../../theme/slider'
import 'swiper/css'

const SLIDE_WIDTH = 380
const SLIDE_GAP = 40
const MOBILE_SLIDE_WIDTH = 260
const MOBILE_SLIDE_GAP = 20

export default function InspiringStoriesSection() {
  const swiperRef = useRef(null)
  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const updateNavState = (swiper) => {
    setIsBeginning(swiper.isBeginning)
    setIsEnd(swiper.isEnd)
  }

  const slidePrev = () => swiperRef.current?.slidePrev()
  const slideNext = () => swiperRef.current?.slideNext()

  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: homeMobilePaddingX,
        py: homeSectionPy,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ maxWidth: 1520 }}>
        <SectionCarouselHeader
          title="Inspiring Stories"
          titleSx={{
            ...homeSectionTitleSx,
            mb: 0,
            [HOME_MOBILE_MQ]: { fontSize: 28 },
          }}
          onPrev={slidePrev}
          onNext={slideNext}
          prevDisabled={isBeginning}
          nextDisabled={isEnd}
          headerSx={{ mb: { xs: '32px', md: '80px' } }}
        />

        <Box
          sx={{
            mx: { xs: '-20px', sm: 0 },
            px: { xs: '20px', sm: 0 },
            overflow: 'hidden',
            mb: { xs: '32px', sm: 0 },
            [HOME_MOBILE_MQ]: { mx: '-20px', px: '20px', mb: '32px' },
            '& .swiper': { overflow: 'visible' },
            '& .swiper-slide': {
              width: {
                xs: `${MOBILE_SLIDE_WIDTH}px !important`,
                sm: '300px !important',
                md: '340px !important',
                lg: `${SLIDE_WIDTH}px !important`,
              },
              height: 'auto',
              flexShrink: 0,
              [HOME_MOBILE_MQ]: {
                width: `${MOBILE_SLIDE_WIDTH}px !important`,
              },
            },
          }}
        >
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper
              updateNavState(swiper)
            }}
            onSlideChange={updateNavState}
            onResize={updateNavState}
            slidesPerView="auto"
            spaceBetween={MOBILE_SLIDE_GAP}
            observer
            observeParents
            resizeObserver
            grabCursor
            speed={SLIDER_TRANSITION_SPEED_DEFAULT}
            watchOverflow
            breakpoints={{
              426: { spaceBetween: 24 },
              900: { spaceBetween: SLIDE_GAP },
            }}
            style={{ overflow: 'visible' }}
          >
            {inspiringStories.map((story) => (
              <SwiperSlide key={story.title}>
                <StoryVideoCard {...story} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>

        <SectionCarouselFooterNav
          onPrev={slidePrev}
          onNext={slideNext}
          prevDisabled={isBeginning}
          nextDisabled={isEnd}
        />
      </Box>
    </Box>
  )
}
